// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2d06e9fa","239":"eab0352a","667":"df274394"}[chunkId] + ".chunk.js";
};